import styles from "./ConfigurePage.module.css";
import { InfoPanel } from "../components/common/InfoPanel";

interface NotFoundPageProps {
	message: string;
}

function NotFoundPage({ message }: NotFoundPageProps) {
	return (
		<main className={styles.main}>
			<div className={styles.container}>
				<InfoPanel type="error" message={message} />
			</div>
		</main>
	);
}

export default NotFoundPage;
